import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard/Dashboard'
import userService from '@/api/authentication'
import Orders from '@/components/Orders/Orders'
import OrdersNew from '@/components/Orders/OrdersNew'
import PatientRoutine from '@/components/PatientRoutine/PatientRoutine'
import Results from '@/components/Results/Results'
import ResultsMainView from '@/components/Results/ResultsMainView'
import ResultsMainFilter from '@/components/Results/ResultsMainFilter'
import Admin from '@/components/Admin/Admin'
import Download from '@/components/Download/Download'
import Paternity from '@/components/Paternity/Paternity'
import ComunicationManagement from '@/components/Comunication/Management/ComunicationManagement'
import VoucherNew from '@/components/Voucher/VoucherNew'
import PrintTag from '@/components/PrintTag/PrintTag'
import Pendencies from '@/components/Pendencies/Pendencies'
import PendenciesMainView from '@/components/Pendencies/PendenciesMainView'
import Traceability from '@/components/Traceability/Traceability'
import TraceabilityMainView from '@/components/Traceability/TraceabilityMainView'
import TraceabilityMainViewV2 from '@/components/TraceabilityV2/TraceabilityMainView'
import SamplesTraceability from '@/components/SamplesTraceability/SamplesTraceability'
import PrintLabels from '@/components/PrintLabels/PrintLabels'
import Batch from '@/components/Batch/Batch'
import Batches from '@/components/PrintLabels/Batches/Batches'
import LegacyBatches from '@/components/PrintTag/Batches/Batches'
import LegacySamples from '@/components/PrintTag/Samples/Samples'
import DocumentsNew from '@/components/Documents/Management/New/DocumentsNew'
import DocumentsLink from '@/components/Documents/Management/Link/DocumentsLink'
import BatchDetails from '@/components/PrintTag/Batches/BatchDetails'
import Samples from '@/components/PrintLabels/Samples/Samples'
import AvailableDocuments from '@/components/AvailableDocuments/AvailableDocuments'
import AvailableDocumentsMainView from '@/components/AvailableDocuments/AvailableDocumentsMainView'
import Recollect from '@/components/Recollect/Recollect'
import RecollectMainView from '@/components/Recollect/RecollectMainView'
import Reschedule from '@/components/Reschedule/Reschedule'
import RescheduleMainView from '@/components/Reschedule/RescheduleMainView'
import RescheduleMainFilter from '@/components/Reschedule/RescheduleMainFilter'
import PanicAlert from '../components/PanicAlert/PanicAlert'
import PanicAlertMainView from '../components/PanicAlert/PanicAlertMainView'
import CollectionPointManagement from '@/components/CollectionPoint/CollectionPointManagement'
import ExamProfiles from '@/components/ExamProfiles/ExamProfiles'
import ExamProfilesNew from '@/components/ExamProfiles/ExamProfilesNew'
import HelpCenterMainView from '@/components/HelpCenter/HelpCenterMainView'
import PatientMainView from '@/components/Patient/PatientMainView'
import PatientNew from '@/components/Patient/PatientNew'
import DoctorMainView from '@/components/Doctor/DoctorMainView'
import DoctorNew from '@/components/Doctor/DoctorNew'
import ReportGeneratorMainView from '@/components/ReportGenerator/ReportGeneratorMainView'
import ExamGuide from '@/components/ExamGuide/ExamGuide'
import ExamGuideResult from '@/components/ExamGuide/ExamGuideResult'
import ExamDetail from '@/components/ExamGuide/ExamDetail'
import SuppliesView from '@/components/Supplies/SuppliesView'
import SuppliesDetailView from '@/components/Supplies/SuppliesDetailView'
import SupplyMainFilter from '@/components/Supplies/SupplyMainFilter'
import SupplyRequestView from '@/components/Supplies/SupplyRequestView'
import FrenquencyQuestion from '@/components/FrequentQuestions/FrequentQuestionsMainView'
import RequiredDocsView from '@/components/RequiredDocs/RequiredDocsMainView'
import InvoicingMainView from '@/components/Invoicing/InvoicingMainView'
import InvoiceDetails from '@/components/Invoicing/InvoiceDetails'
import PaymentStatementView from '@/components/Invoicing/PaymentStatementView'
import ResultsPDFMainView from '@/components/ResultsPDF/ResultsPDFMainView'
import ResultsHistoryMainView from '@/components/ResultsHistory/ResultsHistoryMainView'
import AlvaroValidate from '@/components/AlvaroValidate/AlvaroValidate'
import GeneralDataMainView from '@/components/GeneralData/GeneralDataMainView'
import NotFound from '@/components/404/404'
import NewLogin from '@/components/Login/NewLogin'
import { getCookie } from '@/utils/auth-utils'
import DashboardV2 from '@/components/DashboardV2/Dashboard'
import { toggleDefaultData } from '@/api/toggle'
import LogisticTraceability from '../components/SamplesTraceability/LogisticTraceability'
import LogisticTraceabilityBatches from '../components/SamplesTraceability/LogisticTraceabilityBatches'
import LogisticTraceabilitySamples from '../components/SamplesTraceability/LogisticTraceabilitySamples'
import ProductionTraceability from '../components/SamplesTraceability/ProductionTraceability'
import TraceabilityLogisticBatches from '../components/TraceabilityLogisticBatches/TraceabilityLogisticBatches'
import TraceabilitySearch from '@/components/TraceabilityV2/TraceabilitySearch'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: NewLogin,
      beforeEnter(to, from, next) {
        if (userService.isAuthenticated()) {
          next('/dashboard');
        } else {
          next();
        }
      },
      meta: {
        // Disable menu on login screen
        hideMenu: true,
        hideHeader: true,
        hideNotificationsBar: true,
        hideGuideTour: true,
        hidePreferenceBar: true,
        hideStepperBar: true,
        hideDocumentUploadModal: true,
      },
    },
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/exames',
      name: 'Exames',
      component: ExamGuide,
      meta: {
        // Disable menu on exam guide
        hideMenu: true,
        hideHeader: true,
        hideNotificationsBar: true,
        hideGuideTour: true,
        hidePreferenceBar: true,
        hideStepperBar: true,
        hideDocumentUploadModal: true,
        hideExamGuideView: true,
        dontNeedLoggedUser: true,
      },
      children: [
        {
          path: 'resultado-da-pesquisa',
          name: 'Resultado da pesquisa',
          component: ExamGuideResult,
          meta: {
            // Disable menu on exam guide
            hideMenu: true,
            hideHeader: true,
            hideNotificationsBar: true,
            hideGuideTour: true,
            hidePreferenceBar: true,
            hideStepperBar: true,
            hideDocumentUploadModal: true,
            dontNeedLoggedUser: true,
          },
        },
        {
          path: 'detalhes',
          name: 'Detalhes do Exame',
          component: ExamDetail,
          meta: {
            // Disable menu on exam guide
            hideMenu: true,
            hideHeader: true,
            hideNotificationsBar: true,
            hideGuideTour: true,
            hidePreferenceBar: true,
            hideStepperBar: true,
            hideDocumentUploadModal: true,
            dontNeedLoggedUser: true,
          },
        },
      ],
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: async () => {
        const toggleData = toggleDefaultData()

        return toggleData?.feature.traceability ? DashboardV2 : Dashboard
      },
    },
    {
      path: '/orders/upload',
      name: 'Upload de XML',
      component: Dashboard,
    },
    {
      path: '/orders',
      name: 'Listagem de Ordens de Serviço',
      component: Orders,
      meta: {
        menuOrdersActive: true,
        feature: 'manualServiceOrderRegistration',
      },
    },
    {
      path: '/patient-routine',
      name: 'Rotina do Paciente',
      component: PatientRoutine,
    },
    {
      path: '/orders/new',
      name: 'Cadastrar Ordem de Serviço',
      component: OrdersNew,
      meta: {
        feature: 'manualServiceOrderRegistration',
      },
    },
    {
      path: '/orders/edit/:orderid',
      name: 'Editar Ordem de Serviço',
      component: OrdersNew,
      meta: {
        feature: 'manualServiceOrderRegistration',
      },
    },
    {
      path: '/orders/recollect/:requestid',
      name: 'Recoletar Ordem de Serviço',
      component: OrdersNew,
      meta: {
        feature: 'manualServiceOrderRegistration',
      },
    },
    {
      path: '/orders/patient/:patientid',
      name: 'Cadastrar Ordem de Serviço para Paciente',
      component: OrdersNew,
      meta: {
        feature: 'manualServiceOrderRegistration',
      },
    },
    {
      path: '/results',
      name: 'Results',
      component: Results,
      children: [
        {
          path: 'list',
          name: 'Listagem de Resultados XML',
          component: ResultsMainView,
        },
        {
          path: 'filter',
          alias: '',
          name: 'Filtrar Resultados XML',
          component: ResultsMainFilter,
          meta: {
            feature: 'results',
          },
        },
      ],
    },
    {
      path: '/paternity',
      name: 'Paternity',
      component: Paternity,
      meta: {
        feature: 'paternity',
      },
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {
        feature: 'toggleManage',
      },
    },
    {
      path: '/downloads',
      name: 'Download',
      component: Download,
    },
    {
      path: '/comunication-management',
      name: 'Central de Avisos',
      component: ComunicationManagement,
      meta: {
        feature: 'notification_edit',
      },
    },
    {
      path: '/voucher/new',
      name: 'Voucher Interlaboratorial',
      component: VoucherNew,
      meta: {
        feature: 'interlabVoucher',
      },
    },
    {
      path: '/print-tag/',
      name: 'Impressão de Etiquetas',
      component: async () => {
        const toggleData = toggleDefaultData();

        return toggleData?.feature.nonSegregatedBatchList ? PrintLabels : PrintTag;
      },
      meta: {
        feature: 'tagPrint',
      },
      children: [
        {
          path: 'batches',
          name: 'Impressão de Etiquetas - Lotes',
          component: async () => {
            const toggleData = toggleDefaultData();

            return toggleData?.feature.nonSegregatedBatchList ? Batches : LegacyBatches;
          },
          meta: {
            feature: 'tagPrint',
          },
        },
        {
          path: 'samples',
          name: 'Impressão de Etiquetas - Amostras',
          component: async () => {
            const toggleData = toggleDefaultData();

            return toggleData?.feature.nonSegregatedBatchList ? Samples : LegacySamples;
          },
          meta: {
            feature: 'tagPrint',
          },
        },
        /** @todo: Remove this route when the legacy batch details is removed. */
        {
          path: 'batches/:batchid',
          name: 'legacyBatchDetails',
          component: BatchDetails,
          beforeEnter(to, from, next) {
            const toggleData = toggleDefaultData();

            if (toggleData?.feature.nonSegregatedBatchList) {
              next({
                name: 'batchDetails',
                params: to.params,
              });
            } else next();
          },
          meta: {
            feature: 'tagPrint',
          },
        },
      ],
    },
    {
      path: '/print-tag/batches/:batchid',
      name: 'batchDetails',
      component: async () => {
        const toggleData = toggleDefaultData();

        return toggleData?.feature.nonSegregatedBatchList ? Batch : BatchDetails;
      },
    },
    {
      path: '/create-batch',
      name: 'Criação de Lotes',
      component: Batch,
    },
    {
      path: '/documents/new',
      name: 'Cadastro de Documentos',
      component: DocumentsNew,
    },
    {
      path: '/documents/link',
      name: 'Associar Documentos à Exames',
      component: DocumentsLink,
    },
    {
      path: '/pendencies/',
      name: 'Pendências',
      component: Pendencies,
      children: [
        {
          path: 'list',
          name: 'Listagem de Pendências',
          component: PendenciesMainView,
        },
      ],
    },
    {
      path: '/traceability',
      name: 'Busca Global - Rastreabilidade',
      component: async () => {
        const toggleData = toggleDefaultData()

        return toggleData?.feature.traceability ? SamplesTraceability : Traceability
      },
      meta: {
        feature: 'sampleTraceability',
      },
      children: [
        {
          path: 'batches',
          name: 'traceabilityLogisticBatches',
          component: TraceabilityLogisticBatches,
        },
        {
          path: 'search',
          name: 'Resultados da busca global',
          component: async () => {
            const toggleData = toggleDefaultData()

            return toggleData?.feature.traceability
              ? TraceabilitySearch
              : TraceabilityMainView
          },
          meta: {
            feature: 'sampleTraceability',
          },
        },
        {
          path: 'logistic',
          name: 'logisticTraceability',
          meta: {
            feature: 'traceability',
          },
          component: LogisticTraceability,
          children: [
            {
              path: 'batches',
              name: 'logisticTraceabilityBatches',
              meta: {
                feature: 'traceability',
              },
              component: LogisticTraceabilityBatches,
            },
            {
              path: 'samples',
              name: 'logisticTraceabilitySamples',
              meta: {
                feature: 'traceability',
              },
              component: LogisticTraceabilitySamples,
            },
          ],
        },
        {
          path: 'production',
          name: 'productionTraceability',
          meta: {
            feature: 'traceability',
          },
          component: ProductionTraceability,
        },
      ],
    },
    {
      path: '/availableDocuments/',
      name: 'Documentos disponíveis',
      component: AvailableDocuments,
      children: [
        {
          path: 'search',
          name: 'Resultados dos documentos disponíveis',
          component: AvailableDocumentsMainView,
        },
      ],
    },
    {
      path: '/recollect/',
      name: 'Gestão de Recoletas',
      component: Recollect,
      children: [
        {
          path: 'search',
          name: 'Listagem de recoletas',
          component: RecollectMainView,
        },
      ],
    },
    {
      path: '/reschedule/',
      name: 'Gestão de Remarcações',
      component: Reschedule,
      meta: {
        feature: 'rescheduleList',
      },
      children: [
        {
          path: 'filter',
          name: 'Filtro de remarcações',
          component: RescheduleMainFilter,
          meta: {
            feature: 'rescheduleList',
          },
        },
        {
          path: 'search',
          name: 'Listagem de remarcações',
          component: RescheduleMainView,
          meta: {
            feature: 'rescheduleList',
          },
        },
      ],
    },
    {
      path: '/panic-alert/',
      name: 'Gestão de Alertas de Pânico',
      component: PanicAlert,
      children: [
        {
          path: 'search',
          name: 'Listagem de alertas de pânico',
          component: PanicAlertMainView,
        },
      ],
    },
    {
      path: '/collection-point-management/',
      name: 'Gestão de Pontos de Coleta',
      component: CollectionPointManagement,
    },
    {
      path: '/exam-profiles',
      name: 'Listagem de perfis de exames',
      component: ExamProfiles,
    },
    {
      path: '/exam-profiles/new',
      name: 'Cadastrar perfis de exames',
      component: ExamProfilesNew,
    },
    {
      path: '/exam-profiles/edit/:id',
      name: 'Editar perfis de exames',
      component: ExamProfilesNew,
    },
    {
      path: '/central-de-ajuda/',
      name: 'Central de Ajuda',
      component: HelpCenterMainView,
      meta: {
        feature: 'helpCenterTutorial',
      },
    },
    {
      path: '/perguntas-frequentes/',
      name: 'Perguntas frequentes',
      component: FrenquencyQuestion,
    },
    {
      path: '/patient',
      name: 'Listagem de pacientes',
      component: PatientMainView,
    },
    {
      path: '/patient/new',
      name: 'Cadastrar pacientes',
      component: PatientNew,
    },
    {
      path: '/patient/edit/:id',
      name: 'Editar pacientes',
      component: PatientNew,
    },
    {
      path: '/doctor',
      name: 'Listagem de médicos',
      component: DoctorMainView,
    },
    {
      path: '/doctor/new',
      name: 'Cadastrar médicos',
      component: DoctorNew,
    },
    {
      path: '/doctor/edit/:id',
      name: 'Editar médicos',
      component: DoctorNew,
    },
    {
      path: '/gerar-relatorios/',
      name: 'Gerar relatórios',
      component: ReportGeneratorMainView,
    },
    {
      path: '/gestao-de-insumos',
      name: 'Gestão de Insumos',
      component: SuppliesView,
      meta: {
        feature: 'supplyManagement',
      },
    },
    {
      path: '/gestao-de-insumos/detalhes-da-solicitacao/:id',
      name: 'Detalhes do Pedido',
      component: SuppliesDetailView,
      meta: {
        feature: 'supplyManagement',
      },
    },
    {
      path: '/gestao-de-insumos/filtrar',
      name: 'Filtrar gestão de insumos',
      component: SupplyMainFilter,
      meta: {
        feature: 'supplyManagement',
      },
    },
    {
      path: '/gestao-de-insumos/criar-solicitacao',
      name: 'Criar solicitação de insumos',
      component: SupplyRequestView,
      meta: {
        feature: 'supplyManagement',
      },
    },
    {
      path: '/gestao-de-insumos/editar-solicitacao/:id',
      name: 'Editar solicitação de insumos',
      component: SupplyRequestView,
      meta: {
        feature: 'supplyManagement',
      },
    },
    {
      path: '/documentos-obrigatorios',
      name: 'Documentos obrigatórios',
      component: RequiredDocsView,
    },
    {
      path: '/faturamento',
      name: 'Faturamento',
      component: InvoicingMainView,
      meta: {
        feature: 'billetLink',
      },
    },
    {
      path: '/faturamento/:id/:month/:year',
      name: 'Faturamento Detalhes',
      component: InvoiceDetails,
    },
    {
      path: '/faturamento-extrato',
      name: 'Faturamento Extrato',
      component: PaymentStatementView,
    },
    {
      path: '/results-pdf',
      name: 'Resultados - Download PDF',
      component: ResultsPDFMainView,
    },
    {
      path: '/results-history',
      name: 'Resultados - Laudo Histórico',
      component: ResultsHistoryMainView,
    },
    {
      path: '/valida',
      name: 'Valida Alvaro Apoio',
      component: AlvaroValidate,
      meta: {
        hideMenu: true,
        hideHeader: true,
        hideNotificationsBar: true,
        hideGuideTour: true,
        hidePreferenceBar: true,
        hideStepperBar: true,
        hideDocumentUploadModal: true,
        hideExamGuideView: true,
        dontNeedLoggedUser: true,
      },
      children: [
        {
          path: 'token/s/:id',
          name: 'Valida Token',
          component: AlvaroValidate,
          meta: {
            hideMenu: true,
            hideHeader: true,
            hideNotificationsBar: true,
            hideGuideTour: true,
            hidePreferenceBar: true,
            hideStepperBar: true,
            hideDocumentUploadModal: true,
            dontNeedLoggedUser: true,
          },
        },
      ],
    },
    {
      path: '/dados-cadastrais',
      name: 'Dados Cadastrais',
      component: GeneralDataMainView,
    },
    { path: '*', component: NotFound },
  ],
})

router.beforeEach((to, from, next) => {
  const examGuideRoutes = ['Exames', 'Resultado da pesquisa', 'Detalhes do Exame']
  const alwaysAllowedRoutes = ['Login', 'Valida Alvaro Apoio', 'Valida Token']
  const toggleCookie = getCookie('toggleAol')
  const toggleFeature = (toggleCookie && toggleCookie.feature) || {}

  const isExamGuideURL = examGuideRoutes.includes(to.name)
  const isPublicRoute = alwaysAllowedRoutes.includes(to.name)

  if (userService.isAuthenticated() || isPublicRoute || isExamGuideURL) {
    if (to.meta.feature && !toggleFeature[to.meta.feature]) {
      return next('/404')
    }

    return next()
  } else {
    return next('/login')
  }
});

export default router;
